const INFO = {
	main: {
		title: "Portfolio",
		name: "Kanwar Ammar Ali",
		email: "kanwarammar95@gmail.com",
		logo: "../Illustration_Me1.jpg",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/kanwar-ammar",
		linkedin: "https://www.linkedin.com/in/kanwar-ammar/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Kanwar Ammar",
		description:
			"Hi, I'm Kanwar Ammar, a full stack engineer specializing in MERN technologies with a focus on backend development. I have experience in building scalable, secure, and reliable web applications. I enjoy solving complex problems, learning new skills, and creating high-quality code that follows best practices. I'm always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Kanwar Ammar I live in Pakistan, I help people with innovative technical solutions.",
		description:
			"I've worked on various projects over the years and am proud of my progress. My professional projects are based on the MERN stack and include databases like MySQL. My academic projects demonstrate my understanding of other languages and my creativity. I'm always eager to learn and explore innovative technologies, and I'm open to new ideas and feedback.",
	},

	articles: {
		title: "Here, I outline key milestones of my academic and professional journey, reflecting my passion for continuous growth and learning.",
		description:
			"My journey of thorugout what I have achieved and where I've been till now.",
	},

	projects: [
		{
			title: "Indi Music",
			description:
				"A music application where users can register, import their playlists from Spotify and Deezer, create new playlists, and enjoy songs from multiple applications on a single platform.",
			logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/Spotify_logo_without_text.svg/1024px-Spotify_logo_without_text.svg.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "NextQuestUp",
			description:
				"A live platform that connects artists and users, allowing users to request songs during a music event or party with a single request to the artist.",
			logo: "../Project2logo.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		// {
		// 	title: "The Book Store",
		// 	description:
		// 		"Lorem ipsum dolor sit amet. Et incidunt voluptatem ex tempore repellendus qui dicta nemo sit deleniti minima.",
		// 	logo: "https://www.svgrepo.com/show/183118/library-book.svg",
		// 	linkText: "View Project",
		// 	link: "https://github.com",
		// },

		{
			title: "LMS",
			description:
				"An intra-organization LMS with various roles, allowing users to create custom, embedded, or SCORM courses for employees to learn and earn certificates. The platform handles authentication, certification, and reporting for all learners.",
			logo: "https://cdn-icons-png.flaticon.com/512/2904/2904847.png",
			linkText: "View Project",
			link: "https://github.com",
		},
	],

	personalProjects: [
		{
			title: "E-Voting System",
			description:
				"An online electronic voting system where users can create events, allow others to vote by a specified deadline, tally votes for competitors, and announce a winner.",
			logo: "https://cdn-icons-png.flaticon.com/512/1533/1533890.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Backgammon",
			description:
				"Backgammon is a two-player board game built using a stack data structure. Players roll dice, place their tokens accordingly, and receive possible moves for their tokens. The winner is announced when a player has no possible moves or loses all their tokens.",
			logo: "https://cdn-icons-png.flaticon.com/512/103/103234.png",
			linkText: "View Project",
			link: "https://github.com",
		},
		{
			title: "Diet Recommendation System",
			description:
				"A diet recommendation system that uses unsupervised learning to categorize people into three groups: underweight, healthy, and obese.",
			logo: "https://cdn-icons-png.flaticon.com/512/1784/1784216.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "AI-Based Event Coverage",
			description:
				"This project involved a drone capturing activities, objects, and people at events, with modes like surveillance and photography controlled by hand gestures. Built upon Machine Learning and AI with the concepts of hand body landmark detection, face detection, and multiple object objection.",
			logo: "https://cdn-icons-png.flaticon.com/512/90/90909.png",
			linkText: "View Project",
			link: "https://github.com",
		},
	],
};

export default INFO;
